import React from 'react';

import { IContentfulImage } from '../../../interfaces/contentful-image.interface';
import { TextArrayProps } from '../../page-components/editorial-page-full-width/editorial-page-full-width';
import EditorialPageFullWidthTextWrapper, {
  FullWidthTextBlockProps,
} from '../../page-components/editorial-page-full-width/editorial-page-full-width-text-wrapper';
import EditorialPageFullWidthWrapper from '../../page-components/editorial-page-full-width/editorial-page-full-width-wrapper';
import { gql } from '@apollo/client';
import Image from 'next/image';

export interface FullWidthBannerProps extends FullWidthTextBlockProps {
  banner?: IContentfulImage;
  textItem?: TextArrayProps;
  topBlock?: boolean;
}

const EditorialFullWidthBannerBlock = ({
  banner,
  body,
  textItem,
  topBlock,
}: FullWidthBannerProps) => {
  const image = banner?.url ? banner?.url : null;
  return (
    <EditorialPageFullWidthWrapper
      banner={true}
      topBlock={topBlock ? topBlock : null}
      isImage={image ? true : false}
    >
      {image && (
        <img
          alt=""
          src={image}
          width={banner?.width ? parseInt(banner?.width) : 1500}
          height={banner?.height ? parseInt(banner?.height) : 1000}
          className={
            'aspect-1.5/1 w-full transform-gpu rounded-card-mobile xl:max-h-none xl:h-full xl:aspect-[16/9]'
          }
        />
      )}

      <EditorialPageFullWidthTextWrapper
        body={body ? body : undefined}
        textItem={textItem}
      />
    </EditorialPageFullWidthWrapper>
  );
};

export default EditorialFullWidthBannerBlock;
